<template>
  <div>
    <header class="header-global">
      <base-nav
        class="navbar-main shadow"
        transparent
        type=""
        id="navigation"
        effect="light"
        expand
      >
        <router-link slot="brand" class="" to="/">
          <img
            src="img/brand/blue-logo.png"
            alt="logo"
            class="img-fluid"
            width="180px"
          />
        </router-link>

        <div class="row" slot="content-header" slot-scope="{ closeMenu }">
          <div class="col-6 collapse-brand">
            <router-link slot="brand" class="" to="/">
              <img
                src="img/brand/blue-logo.png"
                alt="logo"
                class="img-fluid"
                width="120px"
              />
            </router-link>
          </div>

          <div class="col-6 collapse-close">
            <close-button @click="closeMenu"></close-button>
          </div>
        </div>

        <ul class="navbar-nav align-items-lg-center ml-lg-auto">
          <base-dropdown hover tag="li" class="nav-item">
            <a
              slot="title"
              class="nav-link nav-link-icon"
              data-toggle="dropdown"
              role="button"
            >
              <i class="ni ni-collection d-lg-none"></i>

              <span class="nav-link-inner--text text-default">Products</span>
            </a>

            <router-link to="/enterprise" class="dropdown-item">
              Enterprise
            </router-link>

            <router-link to="/ussd" class="dropdown-item">USSD</router-link>

            <router-link to="/unicard" class="dropdown-item">
              Unicard
            </router-link>
            <router-link to="/mobile" class="dropdown-item">Mobile</router-link>
          </base-dropdown>

          <base-dropdown hover tag="li" class="nav-item">
            <a
              slot="title"
              class="nav-link nav-link-icon"
              data-toggle="dropdown"
              role="button"
            >
              <i class="ni ni-collection d-lg-none"></i>

              <span class="nav-link-inner--text text-default">Customers</span>
            </a>
            <router-link to="/enterprise" class="dropdown-item">
              MNO partners (Dealers)
            </router-link>

            <router-link to="/banks" class="dropdown-item">
              Merchants (Bank and Fintech)
            </router-link>

            <router-link to="/individual" class="dropdown-item">
              Individual
            </router-link>
          </base-dropdown>

          <li class="nav-item">
            <router-link
              to="/business"
              class="nav-link nav-link-inner--text text-default"
            >
              Business
            </router-link>
          </li>

          <li class="nav-item">
            <a
              class="nav-link nav-link-inner--text text-default"
              href="https://developer.topupbox.com"
              target="_blank"
              rel="noopener"
              data-toggle="tooltip"
            >
              Developers
            </a>
          </li>

          <base-dropdown hover tag="li" class="nav-item">
            <a
              slot="title"
              class="nav-link nav-link-icon"
              data-toggle="dropdown"
              role="button"
            >
              <i class="ni ni-collection d-lg-none"></i>

              <span class="nav-link-inner--text text-default">Support</span>
            </a>

            <router-link to="/contact-us" class="dropdown-item">
              Contact Us
            </router-link>

            <router-link to="/faqs" class="dropdown-item">FAQS</router-link>

            <a href="https://medium.com/@topupbox" class="dropdown-item">
              Learn
            </a>
          </base-dropdown>
          <!-- get started -->
          <li class="nav-item d-none d-lg-block ml-lg-4">
            <base-dropdown hover tag="li" class="nav-item d-none d-lg-block ml-lg-4">
              <base-button slot="title" block type="primary" size="lg">
                <span class="btn-inner--icon"></span>
                <span class="text-white">Get Started</span>
              </base-button>

              <!-- dropdown items for get started" -->
              <router-link to="/register" class="dropdown-item">
                MNO partners (dealers)
              </router-link>

              <a
                href="https://dashboard.topupbox.com/direct-signUp"
                target="_blank"
                class="dropdown-item"
              >
                Merchants (Bank and Fintech)
              </a>

              <a href="/individual" target="" class="dropdown-item"
                >Individual
              </a>
            </base-dropdown>
          </li>
        </ul>
      </base-nav>
    </header>
  </div>
</template>

<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";
export default { components: { BaseNav, CloseButton, BaseDropdown } };
</script>

<style scoped>
#navigation {
  position: fixed;
  background-color: #fff !important;
}
</style>
